document.addEventListener("DOMContentLoaded", function () {
    // Function to initialize the accordions
    function initAccordion() {
        const accordions = document.querySelectorAll('.footer-accordion .accordion-details');
        const isMobile = window.innerWidth <= 1024;

        accordions.forEach(accordion => {
            const summary = accordion.querySelector('.accordion-details__summary');
            const content = accordion.querySelector('.accordion-details__content');

            // On mobile: Start closed, and toggle when clicked
            if (isMobile) {
                // Ensure accordion is closed initially on mobile
                accordion.removeAttribute('open');
                summary.setAttribute('aria-expanded', 'false');
                content.style.maxHeight = '0'; // Collapse content on mobile

                // Toggle on click for mobile
                summary.addEventListener('click', function () {
                    if (accordion.hasAttribute('open')) {
                        accordion.removeAttribute('open');
                        summary.setAttribute('aria-expanded', 'false');
                        content.style.maxHeight = '0'; // Collapse
                    } else {
                        accordion.setAttribute('open', 'true');
                        summary.setAttribute('aria-expanded', 'true');
                        content.style.maxHeight = content.scrollHeight + 'px'; // Expand
                    }
                });
            } else {
                // On Desktop: Always open
                accordion.setAttribute('open', 'true');
                summary.setAttribute('aria-expanded', 'true');
                content.style.maxHeight = content.scrollHeight + 'px'; // Ensure content is fully expanded
            }
        });
    }
    // Initialize accordion
    initAccordion();
    // Debounced resize event listener
    let resizeTimeout;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
            initAccordion();
        }, 200); // Debounce delay (200ms)
    });
});
